export type SignalListener<T> = (payload: T) => void;

export class Signal<T = void> {
  private listeners: Set<SignalListener<T>> = new Set();

  on(listener: SignalListener<T>): () => void {
    this.listeners.add(listener);
    return () => this.off(listener);
  }

  once(listener: SignalListener<T>): () => void {
    const wrapped: SignalListener<T> = (p) => {
      this.off(wrapped);
      listener(p);
    };
    return this.on(wrapped);
  }

  off(listener: SignalListener<T>): void {
    this.listeners.delete(listener);
  }

  emit(payload: T): void {
    for (const listener of this.listeners) {
      try {
        listener(payload);
      } catch (err) {
        console.error("[Signal] listener threw:", err);
      }
    }
  }

  clear(): void {
    this.listeners.clear();
  }

  get size(): number {
    return this.listeners.size;
  }
}
